import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplierBasketUiModule } from '@lib/basket/suppliers-basket/basket-supplier/ui';
import { BasketSupplierFeatureComponent } from './basket-suppliers-basket-basket-supplier-feature/basket-supplier-feature.component';

@NgModule({
    imports: [CommonModule, SupplierBasketUiModule],
    declarations: [BasketSupplierFeatureComponent],
    exports: [BasketSupplierFeatureComponent],
})
export class SupplierBasketFeatureModule {}
